import { lazy } from "react";
const PlayerMatchesComponent = lazy(
  () => import("./playerMatchesComponent/PlayerMatchesComponent")
);
const PlayerProfileComponent = lazy(
  () => import("./playerProfileComponent/PlayerProfileComponent")
);
const PlayerTrophiesComponent = lazy(
  () => import("./playerTrophiesComponent/PlayerTrophiesComponent")
);
const PlayerTransfersComponent = lazy(
  () => import("./playerTransfersComponent/PlayerTransfersComponent")
);
const PlayerStatsComponent = lazy(
  () => import("./playerStatsComponent/PlayerStatsComponent")
);
const Components = {
  PlayerProfile: PlayerProfileComponent,
  PlayerMatches: PlayerMatchesComponent,
  PlayerTrophies: PlayerTrophiesComponent,
  PlayerTransfers: PlayerTransfersComponent,
  PlayerStats: PlayerStatsComponent
};
export {
  Components
};
